import { Controller } from "@hotwired/stimulus";

// Assigning jobs to the cells of the organizers' timetable. Click cells to
// select them. One selected cell can hold several jobs (separated by " | ");
// several selected cells all get one job. Every change is saved at once.
export default class extends Controller {
  static targets = ["assignForm", "multiForm", "assignSelect", "multiSelect", "list"];
  static values = {url: String};

  get selected() {
    return Array.from(this.element.querySelectorAll(".timetable-cell.selected"));
  }

  // The jobs of the (only) selected cell.
  get jobs() {
    const text = this.selected[0]?.textContent.trim() || "";
    return text.split(" | ").filter((job) => job !== "");
  }

  select(event) {
    event.currentTarget.classList.toggle("selected");
    const count = this.selected.length;
    this.assignFormTarget.hidden = count <= 1;
    this.multiFormTarget.hidden = count !== 1;
    if (count === 1) this.renderJobs(this.jobs);
  }

  // Several cells selected: one job (or none) for all of them.
  assign() {
    this.save(this.assignSelectTarget.value || "");
    this.update(this.assignSelectTarget.value || "", true);
  }

  // One cell selected: add a job to it.
  addJob() {
    const jobs = this.jobs;
    const job = this.multiSelectTarget.value;
    if (job && !jobs.includes(job)) jobs.push(job);
    this.commit(jobs);
  }

  removeJob(event) {
    const link = event.target.closest(".remove_multiassign_entry");
    if (!link) return;
    event.preventDefault();
    const jobs = this.jobs;
    const index = jobs.indexOf(link.dataset.job);
    if (index >= 0) jobs.splice(index, 1);
    this.commit(jobs);
  }

  commit(jobs) {
    const job = jobs.join(" | ");
    this.save(job);
    this.update(job, false);
    this.renderJobs(jobs);
  }

  renderJobs(jobs) {
    this.listTarget.replaceChildren(
      ...jobs.map((job) => {
        const item = document.createElement("li");
        item.append(`${job} `);
        const link = document.createElement("a");
        link.href = "javascript:void(0);";
        link.className = "remove_multiassign_entry";
        link.dataset.job = job;
        link.innerHTML = '<i class="fa fa-times"></i>';
        item.append(link);
        return item;
      })
    );
  }

  // Shows the job in the selected cells.
  update(job, deselect) {
    this.selected.forEach((cell) => {
      if (deselect) cell.classList.remove("selected");
      cell.classList.toggle("assigned", job !== "" && !job.includes("|"));
      cell.classList.toggle("overassigned", job.includes("|"));
      cell.textContent = job;
    });
  }

  save(job) {
    const cells = this.selected.map((cell) => cell.id).join(",");
    return fetch(this.urlValue, {
      method: "POST",
      credentials: "same-origin",
      headers: {"X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content},
      body: new URLSearchParams({job, cells}),
    });
  }
}
